export default {
  name: "ConfirmModal",
  props: {
    visibleModal: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    handleCancel: Function,
    handleOk: Function,
  },
  methods: {
    onOk() {
      this.handleOk();
    },
    onCancel() {
      this.handleCancel();
    },
  },
};
